module.exports = __webpack_public_path__ + "static/screen-orari-0360c7981f217f28d34f36ddb0926f47.png";